var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDialogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#E9EAED",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7894_59589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 12.2733L19.7263 11.3333L15.9997 15.0599L12.273 11.3333L11.333 12.2733L15.0597 15.9999L11.333 19.7266L12.273 20.6666L15.9997 16.9399L19.7263 20.6666L20.6663 19.7266L16.9397 15.9999L20.6663 12.2733Z",
    fill: "#031434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7894_59589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDialogIcon);
export default __webpack_public_path__ + "static/media/close_dialog_icon.25c9f6f792ad061037ae020a1253e8ff.svg";
export { ForwardRef as ReactComponent };